export default __webpack_public_path__ + "static/media/dashboard.27eb653d.svg";